export default "__VITE_ASSET__Bx26$WHU__"